const Assignment = {

    // FIELDS
    "session": "Session",
    "course": "Course",
    "semester": "Semester",
    "subject": "Subject",
    "title": "Title",
    "submission_date": "Submission Date",
    "max_marks": "Max Marks",
    "description": "Description",
    "file": "File",
    "search": "Search",

    // PAGE HEADER
    "assignment": "Assignment",

    // ERROR
    "error_session": "Select Session",
    "error_course": "Select Course",
    "error_semester": "Select Semester",
    "error_subject": "Select Subject",
    "error_title": "Enter Assignment Title",
    "error_date": "Select Submission Date",
    "error_marks": "Enter Max Marks",
    "error_file": "Upload Assignment File",
    "error_description": "Enter Description",

    // TABLE HEADER
    "table_session": 'SESSION',
    "table_course": 'COURSE',
    "table_semester": 'SEMESTER',
    "table_subject": 'SUBJECT',
    "table_title": 'TITLE',
    "table_date": 'SUBMISSION DATE',
    "table_marks": 'MAX MARKS',

}

export default Assignment;
